import { Box, Flex, Text } from '@chakra-ui/react';
import { useOverviewContext } from '@resistapp/client/contexts/use-overview-context/use-overview-context';
import { MapLegend } from '../map/map-legend/map-legend';
import { theme } from '../shared/theme';

export function OverviewProcessModeHeader() {
  const { processGroupMapData } = useOverviewContext();

  return (
    <Flex
      width="100%"
      px="36px"
      pt={4}
      gap={theme.spacing[4]}
      align="center"
      justify="space-between"
      flexDirection="row"
    >
      <Text
        color={theme.colors.neutral700}
        fontSize={theme.fontSize.h1}
        fontFamily={theme.fontFamily.dmSans}
        fontWeight={theme.fontWeight.bold}
        lineHeight="1"
        letterSpacing="-0.02em"
      >
        Process Overview
      </Text>
      <Box display="flex" justifyContent="flex-end" flexShrink={0}>
        <MapLegend inline data={processGroupMapData} showInfoIcon />
      </Box>
    </Flex>
  );
}
